import React, { useState, useEffect } from 'react';
import LocationImage from '../icons/place';
import PhoneImage from '../icons/phone';
import LetterImage from '../icons/letter';
import Image from 'react-bootstrap/Image';
import OrderedProductsDropdown from '../orderedProductsDropdowns';
import AddOrderedProductForm from '../VP/addOrderedProduct';
import FormModal from '../formModal';
import VPaVerkstedCSS from './verkstedLayout.module.css';
import { axiosAuthFetch } from '../../helpers/apiActions/authFetch';
import Loader from '../loader';
import UpdateVerkstedForm from '../VP/updateVerksted';
import CustomAlert from '../customAlert';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import { API_BASE_URL } from '../../constants';


function VPadminVerkstedLayout({ verksted }) {


    const {image, username, telephone, email, address, orders} = verksted;

    console.log('VERKSTED', verksted);

    const [productsArray, setProductsArray] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [showOrderModal, setShowOrderModal] = useState(false);

    const handleOpenModal = () => {
        setShowModal(true);
    }

    const handleCloseModal = () => {
        setShowModal(false);
    }

    useEffect(() => {
        async function getProducts() {
            try{
                const response = await axiosAuthFetch('https://renowned-oasis-58a898da10.strapiapp.com/api/products?populate=*&pagination[pageSize]=200');
                console.log('PRODUCTSRESPONSE', response);
                setProductsArray(response.data)
            }
            catch(error) {
            console.error(error)
        }
    }
    getProducts();
        //es-lint-disable-next-line
    }, []);

    if(!productsArray) {
        return <Loader />
    }

    const formatPrice = (price) => {
        return new Intl.NumberFormat('no-NO', { style: 'decimal' }).format(price);
    };

    const openModal = async (order) => {
        setIsLoading(true);
        try{
            const response = await axiosAuthFetch(`${API_BASE_URL}/orders/${order.id}?populate=*`)
            console.log('Order details', response.data);
            setSelectedOrder(response.data);
            setShowOrderModal(true);
        } catch(error) {
            console.error(error);
        } finally{
            setIsLoading(false);
        }
    }

    const closeModal = () => {
        setSelectedOrder(null);
        setShowOrderModal(false);
    }

    if(isLoading) {
        return (<Loader />)
    }
    

    return (
        <div>
                {/* <h1 className="mt-4">OVERSIKT</h1> */}
            <div className="container mb-5">
                <div className="row">
                    <div className="col-2 mt-4">
                        <div className="d-flex flex-column justify-content-center align-items-center m-auto">
                            <div className="profile-image-container col-11 m-auto">
                                <Image src={image?.url} fluid alt="Your-profile-picture" style={{ borderRadius: '20px' }}/>
                            </div>
                            <div className="d-flex flex-column mt-3 col-8 m-auto">
                                <p className="user-name">{username}</p>
                                <div className="d-flex mt-5">
                                    <div className="col-1 me-3 "><LocationImage /></div>
                                    <div className="">
                                        <p className="me-3 user-info-text">{address.street}</p>
                                        <p className="user-info-text">{address.zip}, {address.city}</p>
                                    </div>
                                </div>
                                <div className="d-flex mt-2 m-auto">
                                    <div className="col-1 me-3"><PhoneImage /></div>
                                    <p className="user-info-text">{telephone}</p>
                                </div>
                                <div className="d-flex mt-2">
                                    <div className="col-1 me-3"><LetterImage /></div>
                                    <p className="user-info-text">{email}</p>
                                </div>
                                <div className={`${VPaVerkstedCSS.redigerButton} bg-primary`} onClick={handleOpenModal}>
                                    Rediger verkstedinfo
                                </div>
                                <CustomAlert 
                                    show={showModal}
                                    handleClose={handleCloseModal}
                                    message={<UpdateVerkstedForm verksted={verksted} />}
                                    buttonLabel="Lukk"
                                    modalTitle="Rediger informasjon"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-10">
                        <div className='mt-5'>
                            <p>Leverte produkter</p>
                            <FormModal 
                                body={<AddOrderedProductForm 
                                products={productsArray}/>}
                                buttonTitle="Legg til produkt"
                                modalTitle="Legg til produkt"
                                openButtonClass={VPaVerkstedCSS.openButton}
                                closeButtonClass={VPaVerkstedCSS.closeButton}
                            />
                        </div>
                        <OrderedProductsDropdown />
                        <div className={VPaVerkstedCSS.ordreContainer}>
                            <div className={VPaVerkstedCSS.ordre}>Dine ordre</div>
                            <div className={VPaVerkstedCSS.tableContainer}>
                                {orders && orders.length > 0 ? (
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>Bestilt dato</th>
                                                <th>Din kommentar</th>
                                                <th>Total pris</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {orders.map((order) => (
                                                <tr className={VPaVerkstedCSS.hover} key={order.id}>
                                                    <td onClick={() => openModal(order)}>{order?.dateOrdered}</td>
                                                    <td onClick={() => openModal(order)}>{order?.comment}</td>
                                                    <td onClick={() => openModal(order)}>{formatPrice(order.total_price)},-</td>
                                                    <td onClick={() => openModal(order)}>
                                                        {order?.status === 'approved' && 'Godkjent'}
                                                        {order?.status === 'rejected' && 'Avslått'}
                                                        {order?.status === 'pending' && 'Ventende'}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                ) : (
                                    <div className={VPaVerkstedCSS.noOrders}>Ingen ordre funnet</div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {selectedOrder && (
                <Modal show={showOrderModal} onHide={closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Ordredetaljer</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className={VPaVerkstedCSS.modalContainer}>
                            <div className={VPaVerkstedCSS.row}>
                                <div className={VPaVerkstedCSS.underoverskrift}>
                                    Bestilt av: 
                                </div>
                                <div className={VPaVerkstedCSS.dynamisk}>{selectedOrder.attributes.user.data.attributes.username}</div>
                            </div>
                            <div className={VPaVerkstedCSS.row}>
                                <div className={VPaVerkstedCSS.underoverskrift}>
                                    Bestillingsdato: 
                                </div>
                                <div className={VPaVerkstedCSS.dynamisk}>{selectedOrder.attributes.dateOrdered}</div>
                            </div>
                            <div className={VPaVerkstedCSS.produktRow}>
                                <div className={`${VPaVerkstedCSS.produktUnderoverskrift}`}>Produkter:</div>
                            </div>
                            <ul className={VPaVerkstedCSS.produktListeParent}>
                                {selectedOrder.attributes.order_product.map((product) => (
                                    <li className={VPaVerkstedCSS.produktListeChild} key={product.id}>
                                        <div className={VPaVerkstedCSS.info}>- {product.name} - {formatPrice(product.price)},-</div>
                                        <div className={VPaVerkstedCSS.antall}>x {product.quantity}</div>
                                    </li>
                                ))}
                            </ul>
                            <div className={VPaVerkstedCSS.row}>
                                <div className={VPaVerkstedCSS.underoverskrift}>
                                    Total pris: 
                                </div>
                                <div className={VPaVerkstedCSS.dynamisk}>
                                    {formatPrice(selectedOrder.attributes.total_price)},-
                                </div>
                            </div>
                            <div className={VPaVerkstedCSS.row}>
                                <div className={VPaVerkstedCSS.underoverskrift}>
                                    Status:
                                </div>
                                <div className={VPaVerkstedCSS.dynamisk}>
                                    {selectedOrder.attributes.status === 'approved' && 'Godkjent'}
                                    {selectedOrder.attributes.status === 'rejected' && 'Avslått'}
                                    {selectedOrder.attributes.status === 'pending' && 'Ventende'}
                                </div>
                            </div>
                            <div className={VPaVerkstedCSS.row}>
                                <div className={VPaVerkstedCSS.underoverskrift}>Kontaktperson:</div>
                                <div className={VPaVerkstedCSS.dynamisk}>{selectedOrder.attributes.contact_person}</div>
                            </div>
                            <div className={VPaVerkstedCSS.row}>
                                <div className={VPaVerkstedCSS.underoverskrift}>Kontakt e-post:</div>
                                <div className={VPaVerkstedCSS.dynamisk}>{selectedOrder.attributes.contact_email}</div>
                            </div>
                            <div className={VPaVerkstedCSS.row}>
                                <div className={VPaVerkstedCSS.underoverskrift}>Kjøpers kommentar:</div>
                                <div className={VPaVerkstedCSS.dynamisk}>{selectedOrder.attributes.comment}</div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className={VPaVerkstedCSS.button4} onClick={closeModal}>Lukk</div>
                    </Modal.Footer>
                </Modal>
            )}
        </div>
    )
}

export default VPadminVerkstedLayout;